import { ProfileForm } from './profile-form/ProfileForm';
import { Container } from './EditFormContent.styles';
import { SearchSettingsForm } from './search-settings/SearchSettingsForm';
import { CrmForm } from './crm-form/CrmForm';
import { DocumentList } from './document-list/DocumentList';
import { InternalNoteForm } from './internal-note/InternalNoteForm';

export const EditFormContent: React.FC = () => {
  return (
    <Container>
      <ProfileForm defaultExpanded={true} />
      <SearchSettingsForm defaultExpanded={true} />
      <InternalNoteForm defaultExpanded={true} />
      <CrmForm defaultExpanded={true} />
      <DocumentList defaultExpanded={true} />
    </Container>
  );
};
